import { computed } from 'vue'

export default {
    name: 'FundraisingCard',
    props: {
        result: {
            type: Object,
            required: true,
            default: {
                imgUrl: '',
                name: '',
                target: '',
                current: '',
                hideTarget: false
            }
        }
    },
    setup(props) {
        // new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number)

        const target = computed(() =>
            new Intl.NumberFormat('da-DK', {
                style: 'currency',
                currency: 'DKK',
                maximumFractionDigits: 0
            }).format(props.result.target)
        )
        const current = computed(() =>
            new Intl.NumberFormat('da-DK', {
                style: 'currency',
                currency: 'DKK',
                maximumFractionDigits: 0
            }).format(props.result.current)
        )
        const progress = computed(() => {
            // Cap progress at 100%
            const rawProgress =
                (props.result.current * 100) / props.result.target
            return Math.min(rawProgress, 100)
        })

        return {
            target,
            current,
            progress
        }
    }
}
